import PropTypes from 'prop-types';
import React from 'react';
import {
  Add as AddIcon,
  FitScreen,
  Remove as RemoveIcon,
} from '@mui/icons-material';
import {Box} from '@mui/material';

import MapTool from './MapTool.jsx';

const ZoomControls = ({
  zoom,
  maxZoom,
  minZoom,
  onZoomIn,
  onZoomOut,
  onZoomToFeatures,
}) => {
  return (
    <>
      <Box sx={{display: 'flex', flexDirection: 'column'}}>
        <MapTool
          icon={<AddIcon />}
          disabled={zoom >= maxZoom}
          tooltipTitle="Zoom In"
          onClick={e => {
            onZoomIn(e);
          }}
          sx={{
            borderRadius: theme =>
              `${theme.shape.borderRadius}px ${theme.shape.borderRadius}px 0px 0px`,
          }}
          data-testid="zoom-in"
        />
        <MapTool
          icon={<RemoveIcon />}
          disabled={zoom <= minZoom}
          tooltipTitle="Zoom Out"
          onClick={e => {
            onZoomOut(e);
          }}
          sx={{
            borderRadius: theme =>
              `0px 0px ${theme.shape.borderRadius}px ${theme.shape.borderRadius}px`,
          }}
          data-testid="zoom-out"
        />
      </Box>
      {onZoomToFeatures && (
        <MapTool
          icon={<FitScreen />}
          onClick={e => {
            onZoomToFeatures(e);
          }}
          tooltipTitle="Zoom to features"
          sx={{
            marginTop: 0.5,
          }}
          data-testid="zoom-to-features"
        />
      )}
    </>
  );
};

ZoomControls.propTypes = {
  zoom: PropTypes.number,
  maxZoom: PropTypes.number,
  minZoom: PropTypes.number,
  onZoomToFeatures: PropTypes.func,
  onZoomIn: PropTypes.func,
  onZoomOut: PropTypes.func,
};

ZoomControls.defaultProps = {
  onZoomIn: () => {},
  onZoomOut: () => {},
};

export default ZoomControls;
